<template>
  <CSidebar
    fixed
    :minimize="minimizeDesktop"
    :show="show"
    class="panel-sidebar"
    dropdownMode="closeInactive"
    @update:show="onSidebarShow"
  >
    <div class="panel-sidebar__brand">
      <div class="panel-sidebar__brand-main">
        <CImg
          id="logo_image"
          class="panel-sidebar__logo"
          :src="logo_image"
          width="auto"
          height="32"
        />
        <span id="company_name" class="panel-sidebar__name">فروشگاه</span>
      </div>
      <button type="button" class="panel-sidebar__icon-btn d-md-down-none" :title="minimize ? 'باز کردن منو' : 'جمع کردن منو'"
              @click="$store.commit('set', ['sidebarMinimize', !minimize])">
        <CIcon name="iconSidebar"/>
      </button>
      <button type="button" class="panel-sidebar__icon-btn d-lg-none" title="بستن منو" @click="closeMobile">
        <CIcon name="iconClose"/>
      </button>
    </div>

    <div class="panel-sidebar__profile">
      <button type="button" class="panel-sidebar__profile-main" title="پروفایل" @click="$router.push('/dashboard/users/profile')">
        <img class="panel-sidebar__avatar" :src="user_image" alt="" @error="user_image = '/img/user.png'"/>
        <div class="panel-sidebar__who">
          <strong>{{ user_name || 'مدیر' }}</strong>
          <small><i class="panel-sidebar__online"></i>آنلاین</small>
        </div>
      </button>
      <button type="button" class="panel-sidebar__icon-btn" title="مشاهده سایت" @click="openSite">
        <CIcon name="iconExternal"/>
      </button>
    </div>

    <div class="panel-sidebar__search">
      <CIcon name="iconSearch" class="panel-sidebar__search-icon"/>
      <input v-model="nav_query" id="panel-nav-filter" name="panel-nav-filter" type="text" inputmode="search" autocomplete="off" autocapitalize="off" autocorrect="off" spellcheck="false" data-1p-ignore="true" data-lpignore="true" data-bwignore="true" placeholder="جستجو در منو..." @input="_navTyped = true; filterNav()" @keydown.esc="nav_query = ''; filterNav()"/>
    </div>

    <div class="panel-sidebar__label">ناوبری</div>

    <CRenderFunction ref="sidebar_ref" flat :content-to-render="generate_nav"/>
    <div class="panel-sidebar__empty" v-if="nav_query && nav_no_result">موردی یافت نشد</div>

    <button type="button" class="panel-sidebar__cache-btn" :disabled="clearing_cache" title="پاک کردن کش" @click="clearCache">
      <span>{{ clearing_cache ? '...' : 'پاک کردن کش' }}</span>
    </button>

    <button type="button" class="panel-sidebar__logout" title="خروج" @click="logout">
      <CIcon name="iconLogout" class="c-sidebar-nav-icon"/>
      <span>خروج</span>
    </button>
  </CSidebar>
</template>

<script>
import nav from './_nav'
import axios from '@/api/http'

function cloneNav(source) {
  return JSON.parse(JSON.stringify(source))
}

function readPermissions() {
  try {
    const raw = localStorage.getItem('permissions')
    if (!raw) return null
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed) ? parsed : null
  } catch (e) {
    return null
  }
}

export default {
  name: 'TheSidebar',
  nav,
  data() {
    return {
      branch_name: localStorage.getItem("branchName"),
      sidebar_changer: null,
      logo_image: localStorage.getItem("logo_url") ? localStorage.getItem("logo_url") : '/img/panel_icon.png',
      isNarrow: false,
      nav_query: '',
      nav_no_result: false,
      user_name: localStorage.getItem('user_name') || '',
      user_image: localStorage.getItem('user_image') || '/img/user.png',
      permissionsTick: 0,
    }
  },
  computed: {
    show() {
      return this.$store.state.sidebarShow
    },
    minimize() {
      return this.$store.state.sidebarMinimize
    },
    minimizeDesktop() {
      if (this.isNarrow) return false
      return this.minimize
    },
    generate_nav() {
      // depend on tick so nav rebuilds after login permissions load
      void this.permissionsTick

      const out_pot = cloneNav(nav)
      const permissions = readPermissions()
      const children = out_pot[0]._children

      for (let oo = children.length - 1; oo >= 0; oo--) {
        const val = children[oo]

        if (val.items != null) {
          for (let xz = val.items.length - 1; xz >= 0; xz--) {
            const val_item = val.items[xz]
            if (permissions && val_item.role != null && !permissions.includes(val_item.role)) {
              val.items.splice(xz, 1)
            }
          }
          // drop empty dropdowns
          if (val.items.length === 0) {
            children.splice(oo, 1)
            continue
          }
        }

        if (permissions && val.role != null && !permissions.includes(val.role)) {
          children.splice(oo, 1)
        }
      }

      // presentation-only badges
      children.forEach((it) => {
        if (it.to === '/dashboard/media' && !it.badge) it.badge = {color: 'info', text: 'جدید'}
        if (it.items) {
          it.items.forEach((child) => {
            // role is only for filtering — don't pass to DOM
            delete child.role
            delete child.role_access
          })
        }
      })

      return out_pot
    },
  },
  mounted() {
    this.updateNarrow()
    this.loadSiteLogo()
    window.addEventListener('resize', this.updateNarrow)
    window.addEventListener('storage', this.onStorage)
    window.addEventListener('site-logo', this.onSiteLogo)

    // permissions may arrive right after mount (validate-token)
    this.refreshPermissions()
    let polls = 0
    this._permissionsTimer = setInterval(() => {
      this.refreshPermissions()
      if (++polls >= 10) clearInterval(this._permissionsTimer)
    }, 1000)

    this.$nextTick(() => { this.bindDropdownNav(); if (this.nav_query) { this.nav_query = ''; this.filterNav() } })
    setTimeout(() => { if (this.nav_query && !this._navTyped) { this.nav_query = ''; this.filterNav() } }, 600)

    const CLASS_NAME_ACTIVE = 'c-active'
    const SELECTOR_NAV_LINK = '.c-xhr-link, .c-sidebar-nav-link'
    const SELECTOR_NAV_ITEM = '.c-sidebar-nav-item'
    this.$router.afterEach((to) => {
      // Only an explicitly opened mobile drawer closes on navigation; desktop/'responsive' must stay open.
      if (window.innerWidth < 992 && this.$store.state.sidebarShow === true) {
        this.$store.commit('closeSidebarMobile')
      }
      this.$nextTick(() => this.bindDropdownNav())
      setTimeout(() => {
        Array.from(document.querySelectorAll(SELECTOR_NAV_LINK)).forEach(element => {
          element.classList.remove(CLASS_NAME_ACTIVE)
        })
        Array.from(document.querySelectorAll(`${SELECTOR_NAV_ITEM} a[href="${to.path}"]`)).forEach(element => {
          element.classList.add(CLASS_NAME_ACTIVE)
        })
      }, 500)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateNarrow)
    window.removeEventListener('storage', this.onStorage)
    window.removeEventListener('site-logo', this.onSiteLogo)
    if (this._permissionsTimer) clearInterval(this._permissionsTimer)
  },
  methods: {
    onSidebarShow(value) {
      // CoreUI emits show=false on nav clicks / breakpoint changes even on desktop; ignore that there.
      if (!value && typeof window !== 'undefined' && window.innerWidth >= 992) return
      this.$store.commit('set', ['sidebarShow', value])
    },
    onSiteLogo(ev) {
      const url = ev && ev.detail
      this.logo_image = url || '/img/panel_icon.png'
    },
    loadSiteLogo() {
      axios.post('/api/admin/site/get_config', new FormData(), { show_pros: false }).then((res) => {
        const logo = res.data && res.data.configs && res.data.configs.logo
        if (logo) {
          this.logo_image = logo
          localStorage.setItem('logo_url', logo)
        }
      }).catch(() => {})
    },
    refreshPermissions() {
      const raw = localStorage.getItem('permissions') || ''
      if (raw !== this._lastPermissionsRaw) {
        this._lastPermissionsRaw = raw
        this.permissionsTick += 1
        this.$nextTick(() => this.bindDropdownNav())
      }
    },
    onStorage(e) {
      if (!e || e.key === 'permissions' || e.key === null) {
        this.refreshPermissions()
      }
    },
    // WordPress-like: parent click navigates to first submenu page
    bindDropdownNav() {
      const root = this.$refs.sidebar_ref && this.$refs.sidebar_ref.$el
      if (!root) return

      root.querySelectorAll('.c-sidebar-nav-dropdown').forEach((dropdown) => {
        const toggle = dropdown.querySelector(':scope > .c-sidebar-nav-dropdown-toggle')
        if (!toggle || toggle._wpNavBound) return
        toggle._wpNavBound = true

        toggle.addEventListener('click', () => {
          const first = dropdown.querySelector('.c-sidebar-nav-dropdown-items a.c-sidebar-nav-link')
          const href = first && (first.getAttribute('href') || (first.getAttribute('to')))
          if (!href || href === '#') return
          // router-link may use href from resolved route
          if (href.startsWith('/')) {
            if (this.$route.path !== href) {
              this.$router.push(href).catch(() => {})
            }
          }
        })
      })
    },
    // Live filter of the rendered sidebar menu (presentation only).
    filterNav() {
      const root = this.$refs.sidebar_ref && this.$refs.sidebar_ref.$el
      if (!root) return
      const q = (this.nav_query || '').trim().toLowerCase()
      let any = false
      const text = (el) => (el.textContent || '').trim().toLowerCase()
      root.querySelectorAll(':scope > li, .c-sidebar-nav > li').forEach((li) => {
        if (li.parentElement && li.parentElement.classList.contains('c-sidebar-nav-dropdown-items')) return
        if (!q) {
          li.style.display = ''
          li.querySelectorAll('li').forEach((c) => { c.style.display = '' })
          if (li._navOpened) { li.classList.remove('c-show'); li._navOpened = false }
          return
        }
        const toggle = li.querySelector(':scope > a')
        const own = toggle ? text(toggle) : text(li)
        const kids = li.querySelectorAll('.c-sidebar-nav-dropdown-items > li')
        let kidHit = false
        kids.forEach((c) => {
          const hit = own.indexOf(q) >= 0 || text(c).indexOf(q) >= 0
          c.style.display = hit ? '' : 'none'
          if (text(c).indexOf(q) >= 0) kidHit = true
        })
        const show = own.indexOf(q) >= 0 || kidHit
        li.style.display = show ? '' : 'none'
        if (show) any = true
        if (kids.length && kidHit && !li.classList.contains('c-show')) {
          li.classList.add('c-show')
          li._navOpened = true
        }
      })
      this.nav_no_result = !!q && !any
    },
    updateNarrow() {
      this.isNarrow = window.innerWidth < 992
      if (this.isNarrow && this.minimize) {
        this.$store.commit('set', ['sidebarMinimize', false])
      }
    },
    closeMobile() {
      this.$store.commit('closeSidebarMobile')
    },
    clearCache() {
      if (this.clearing_cache) return
      this.clearing_cache = true
      axios.post('/api/admin/site/cache/clear', new FormData(), {}).then((res) => {
        const mc = this.$root.modal_component
        if (mc && res && res.data && res.data.message) mc.show_api_response_modals(res)
        else if (this.$toast && this.$toast.success) this.$toast.success('کش پاک شد')
        else if (mc) mc.show_api_response_modals(res)
      }).catch((e) => {
        console.log(e)
        const mc = this.$root.modal_component
        if (mc) mc.show_danger_toast('خطا در پاک کردن کش')
      }).finally(() => { this.clearing_cache = false })
    },
    openSite() {
      window.open(localStorage.getItem("site_url"))
    },
    logout() {
      localStorage.setItem('token', '')
      this.$router.push({ path: '/dashboard/login' })
    },
    scroll_sidebar() {
    }
  },
}
</script>

<style scoped>
.panel-sidebar__cache-btn { display:flex; align-items:center; justify-content:center; margin:8px 12px 4px; padding:8px 12px; border:0; border-radius:8px; background:#2563eb; color:#fff; font-weight:600; cursor:pointer; }
.panel-sidebar__cache-btn:hover { background:#1d4ed8; }
.panel-sidebar__cache-btn:disabled { opacity:.7; cursor:wait; }
</style>
